<template>
  <div class="login-container">
    <!-- Toast Notification -->
    <Toast />

    <!-- Login content -->
    <router-view />
  </div>
</template>

<script>
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { onMounted } from "vue";
import { notifyService } from "@/helpers/NotifyService";

export default {
  name: "LoginLayout",
  components: {
    Toast,
  },
  setup() {
    const toast = useToast();

    onMounted(() => {
      notifyService.setToastInstance(toast);
    });

    return {
      toast,
    };
  },
};
</script>
